import React, { useContext } from "react";

import { IInputValidationProps, validators } from "components/Form/validators";
import { ISelect } from "./interface";

import CreatableSelect from "react-select/creatable";

import { Container } from "./styles";

import SelectInput from "react-select";

import { FailContext } from "components/Form";
import Text from "components/Text";
import Loader from "components/Loader";

const Select: React.FC<ISelect & any> = (props) => {
  const {
    value,
    styles,
    required,
    name,
    options,
    subjection,
    stateName,
    withSelect,
    width,
    createLabelMessage,
    ...rest
  } = props;
  const fail = useContext(FailContext);

  let isValid = () => {
    if (validators["select"]) {
      const props: IInputValidationProps = {
        value: value,
        name: name,
        required: required,
      };

      return validators["select"](props);
    } else {
      return true;
    }
  };

  const SelectLoader = () => (
    <Loader className="spinner-title absolute" style={{ height: 20, width: 20, right: 45 }} />
  );

  return (
    <Container
      className="d-flex flex-column"
      error={isValid() && fail ? true : false}
      disabled={props.disabled}
      isMulti={props.isMulti}
      width={width || "auto"}
    >
      <input
        data-customtype="select"
        required={required}
        value={value?.value || value || ""}
        disabled
        style={{ display: "none" }}
      />
      {props.isCreatable ? (
        <CreatableSelect
          className={`${rest.className || ""}`}
          value={props.value}
          blurInputOnSelect={props.isMulti ? false : true}
          name={name}
          data-customtype="select"
          isDisabled={props.disabled}
          placeholder={props.placeholder || "Selecione"}
          noOptionsMessage={(obj) => (obj.inputValue = "Nada encontrado.")}
          required={required}
          isLoading={props.isLoading}
          allowCreateWhileLoading={false}
          formatCreateLabel={(inputValue) => `${createLabelMessage || `Criar tag`} "${inputValue}"`}
          loadingMessage={(obj) => (obj.inputValue = "Carregando...")}
          components={{ LoadingIndicator: SelectLoader }}
          options={options}
          {...rest}
        />
      ) : (
        <SelectInput
          className={`${rest.className || ""}`}
          value={props.value || ""}
          blurInputOnSelect={props.isMulti ? false : true}
          name={name}
          data-customtype="select"
          isDisabled={props.disabled}
          placeholder={props.placeholder || "Selecione"}
          noOptionsMessage={(obj) => (obj.inputValue = "Nada encontrado.")}
          required={required}
          isLoading={props.isLoading}
          loadingMessage={(obj) => (obj.inputValue = "Carregando...")}
          components={{ LoadingIndicator: SelectLoader }}
          options={options}
          styles={(style: any, { data }: any) => styles(style, data)}
          {...rest}
        />
      )}
      {isValid() && fail && (
        <Text size={12} className="animated fadeIn mt-1 color-danger">
          {isValid()}
        </Text>
      )}
    </Container>
  );
};

export default Select;
